import styled from 'styled-components'
import { maxQuery } from '../../../helpers'

export default styled.div`
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  header {
    margin-bottom: 2em;

    .top--row {
      h2 {
        color: #fff;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0 0 1em 0;
      }
    }

    .header--row {
      .date-select {
        padding: 0.75em 1em;
        background: #272B4A;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #fff;
        font-size: 0.95rem;
        cursor: pointer;

        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.primary};
        }
      }
    }
  }

  .stats--container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5em;
    margin-bottom: 2em;

    ${maxQuery('md')} {
      grid-template-columns: 1fr;
    }

    .stat-card {
      background: #272B4A;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 1.5em;
      position: relative;
      overflow: hidden;

      .stat-icon {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        margin-bottom: 1em;
      }

      h3 {
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 0 0.5em 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-weight: 600;
      }

      .stat-value {
        font-size: 2rem;
        font-weight: 700;
        color: #fff;
        margin: 0 0 0.5em 0;

        ${maxQuery('md')} {
          font-size: 1.5rem;
        }
      }

      .stat-detail {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.5);
        margin: 0;
      }

      .stat-change {
        font-size: 0.85rem;
        margin: 0;

        &.positive {
          color: #6ABA6D;
        }

        &.negative {
          color: #ef4444;
        }
      }
    }
  }

  .charts--container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 1.5em;
    margin-bottom: 2em;

    ${maxQuery('md')} {
      grid-template-columns: 1fr;
    }

    .chart-card {
      background: #272B4A;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      padding: 1.5em;

      h3 {
        font-size: 1.1rem;
        color: #fff;
        margin: 0 0 1.5em 0;
        padding-bottom: 1em;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-weight: 600;
      }

      .status-chart {
        display: flex;
        flex-direction: column;
        gap: 1.5em;

        .status-item {
          .status-info {
            display: flex;
            align-items: center;
            gap: 0.75em;
            margin-bottom: 0.5em;

            .status-color {
              width: 12px;
              height: 12px;
              border-radius: 50%;
            }

            .status-label {
              color: #fff;
              font-weight: 600;
              font-size: 0.95rem;
            }
          }

          .status-stats {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.5em;

            .status-count {
              color: rgba(255, 255, 255, 0.8);
              font-size: 1.1rem;
              font-weight: 600;
            }

            .status-percentage {
              color: rgba(255, 255, 255, 0.5);
              font-size: 0.9rem;
            }
          }

          .status-bar {
            height: 8px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 4px;
            overflow: hidden;

            .status-bar-fill {
              height: 100%;
              transition: width 0.3s ease;
              border-radius: 4px;
            }
          }
        }
      }

      .riders-list {
        display: flex;
        flex-direction: column;
        gap: 1em;

        .rider-item {
          display: flex;
          align-items: center;
          gap: 1em;
          padding: 1em;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.05);

          .rider-rank {
            width: 36px;
            height: 36px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 0.9rem;
            flex-shrink: 0;
          }

          .rider-info {
            flex: 1;
            display: flex;
            align-items: center;

            .rider-name {
              color: #fff;
              font-weight: 600;
              margin-bottom: 0.25em;
            }

            .rider-stats {
              color: rgba(255, 255, 255, 0.5);
              font-size: 0.85rem;
            }
          }

          .rider-badge {
            padding: 0.5em 1em;
            background: rgba(254, 125, 17, 0.15);
            border: 1px solid rgba(254, 125, 17, 0.3);
            border-radius: 6px;
            color: #FE7D11;
            font-size: 0.85rem;
            font-weight: 600;
            white-space: nowrap;
          }
        }

        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3em 2em;
          text-align: center;
          color: rgba(255, 255, 255, 0.5);

          p {
            margin: 0;
          }
        }
      }
    }
  }

  .additional-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;

    ${maxQuery('md')} {
      grid-template-columns: 1fr;
    }

    .stat-card-small {
      background: #272B4A;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      padding: 1.25em;
      display: flex;
      align-items: center;
      gap: 1em;

      .small-icon {
        font-size: 2rem;
        color: ${({ theme }) => theme.primary};
        opacity: 0.7;
      }

      .small-label {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 0 0.25em 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .small-value {
        font-size: 1.5rem;
        font-weight: 700;
        color: #fff;
        margin: 0;
      }
    }
  }
`
